module.exports = __webpack_public_path__ + "public/images/partners/sup-14.4403ec413cd07365325185b04c4f978a.png";